var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevokeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7052_11666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66666C14.6038 1.66666 18.3346 5.39749 18.3346 9.99999C18.3346 14.6025 14.6038 18.3333 10.0013 18.3333C5.3988 18.3333 1.66797 14.6025 1.66797 9.99999C1.66797 5.39749 5.3988 1.66666 10.0013 1.66666ZM10.0013 12.5C9.78029 12.5 9.56833 12.5878 9.41205 12.7441C9.25577 12.9003 9.16797 13.1123 9.16797 13.3333C9.16797 13.5543 9.25577 13.7663 9.41205 13.9226C9.56833 14.0789 9.78029 14.1667 10.0013 14.1667C10.2223 14.1667 10.4343 14.0789 10.5906 13.9226C10.7468 13.7663 10.8346 13.5543 10.8346 13.3333C10.8346 13.1123 10.7468 12.9003 10.5906 12.7441C10.4343 12.5878 10.2223 12.5 10.0013 12.5ZM10.0013 4.99999C9.79719 5.00002 9.60019 5.07495 9.44766 5.21059C9.29513 5.34622 9.19768 5.53311 9.1738 5.73582L9.16797 5.83332V10.8333C9.1682 11.0457 9.24953 11.25 9.39534 11.4045C9.54115 11.5589 9.74043 11.6519 9.95246 11.6643C10.1645 11.6767 10.3733 11.6078 10.5362 11.4714C10.699 11.3351 10.8037 11.1417 10.8288 10.9308L10.8346 10.8333V5.83332C10.8346 5.61231 10.7468 5.40035 10.5906 5.24407C10.4343 5.08779 10.2223 4.99999 10.0013 4.99999Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7052_11666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokeIcon);
export default __webpack_public_path__ + "static/media/revoke-icon.740102cc2bbb6bb3ecb7d2f77c3ae36f.svg";
export { ForwardRef as ReactComponent };